<template>
  <a-space direction="vertical" style="width:100%" size="middle">
    <a-card :bordered="false">
      <a-space>
        <a-button type="primary" @click="openCreate">Добавить тег</a-button>
        <a-button @click="load" :loading="loading">Обновить</a-button>
      </a-space>
    </a-card>

    <a-card title="Теги" :bordered="false">
      <a-table :dataSource="rows" :columns="columns" :loading="loading" :pagination="false" rowKey="id">
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'kind'">
            {{ label(record.kind) }}
          </template>

          <template v-else-if="column.key === 'active'">
            <a-switch :checked="!!record.active" @change="toggleActive(record)" />
          </template>

          <template v-else-if="column.key === 'actions'">
            <a-button size="small" @click="openEdit(record)">Редактировать</a-button>
          </template>
        </template>
      </a-table>
    </a-card>

    <a-modal v-model:open="editOpen" :title="editing?.id ? 'Редактировать тег' : 'Новый тег'" @ok="save" :confirmLoading="saving">
      <a-form layout="vertical">
        <a-form-item label="Название">
          <a-input v-model:value="form.name" />
        </a-form-item>

        <a-form-item label="Тип">
          <a-select v-model:value="form.kind" :options="kindOptions" />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-space>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { message } from 'ant-design-vue'
import { getKitchenTags, createKitchenTag, updateKitchenTag, setKitchenTagActive } from '../../api/tags'
import { label } from '../../utils/labels'

const loading = ref(false)
const saving = ref(false)
const editOpen = ref(false)
const rows = ref([])
const editing = ref(null)

const form = ref({
  name: '',
  kind: 'OTHER',
})

const kindOptions = [
  { value: 'DIET', label: 'Диета' },
  { value: 'EXCLUDE', label: 'Исключение' },
  { value: 'ALLERGEN', label: 'Аллерген' },
  { value: 'OTHER', label: 'Другое' },
]

const columns = [
  { title: 'Название', dataIndex: 'name' },
  { title: 'Тип', key: 'kind', width: 140 },
  { title: 'Активен', key: 'active', width: 100 },
  { title: '', key: 'actions', width: 160 },
]

async function load() {
  loading.value = true
  try {
    const res = await getKitchenTags()
    rows.value = res.data.data || []
  } catch (e) {
    message.error(e?.response?.data?.error?.message || 'Ошибка загрузки')
  } finally {
    loading.value = false
  }
}

function openCreate() {
  editing.value = null
  form.value = { name: '', kind: 'OTHER' }
  editOpen.value = true
}

function openEdit(row) {
  editing.value = row
  form.value = { name: row.name, kind: row.kind }
  editOpen.value = true
}

async function save() {
  saving.value = true
  try {
    if (editing.value?.id) {
      await updateKitchenTag(editing.value.id, form.value)
    } else {
      await createKitchenTag(form.value)
    }
    editOpen.value = false
    message.success('Сохранено')
    await load()
  } catch (e) {
    message.error(e?.response?.data?.error?.message || 'Ошибка сохранения')
  } finally {
    saving.value = false
  }
}

async function toggleActive(row) {
  try {
    await setKitchenTagActive(row.id, !row.active)
    message.success('Сохранено')
    await load()
  } catch (e) {
    message.error(e?.response?.data?.error?.message || 'Ошибка изменения активности')
  }
}

onMounted(load)
</script>
